import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=449a1629&scoped=true&"
import script from "./Service.vue?vue&type=script&lang=js&"
export * from "./Service.vue?vue&type=script&lang=js&"
import style0 from "./Service.vue?vue&type=style&index=0&id=449a1629&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449a1629",
  null
  
)

export default component.exports